import {
  createAuthActions,
  createBatchActions,
  createCompanyActions,
  createCreditorActions,
  createSettingsActions,
  createSyncActions,
  createTemplateActions,
} from './actions';

function createAppActions(deps) {
  const syncActions = createSyncActions(deps);
  const authActions = createAuthActions(deps);
  const companyActions = createCompanyActions({
    ...deps,
    syncFromApi: syncActions.syncFromApi,
  });
  const creditorActions = createCreditorActions(deps);
  const settingsActions = createSettingsActions({
    ...deps,
    syncFromApi: syncActions.syncFromApi,
  });
  const batchActions = createBatchActions({
    ...deps,
    syncFromApi: syncActions.syncFromApi,
  });
  const templateActions = createTemplateActions({
    ...deps,
    syncFromApi: syncActions.syncFromApi,
  });

  return {
    ...syncActions,
    ...authActions,
    ...batchActions,
    ...templateActions,
    ...companyActions,
    ...creditorActions,
    ...settingsActions,
  };
}

export { createAppActions };
